import React from 'react';
import { Box, Container, Typography,Button } from "@mui/material";
import AccordionDesign from './accrodian.design';
import FaqData from "./faq.data";
const Faq = ()=>{
    return(
            <Container 
                sx={{
                    height:"auto",
                    // backgroundColor: "#dedede",
                    padding: {xs:"20px 20px",md:"80px 40px",lg:"80px 0px"},
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <Box
                    
                >
                    <Typography
                        variant="h3"
                        textAlign="center"
                        gutterBottom
                        sx={{
                            fontSize: {xs:"22px",sm:"28px",md:"34px",lg:"48px"},
                            fontWeight: "700",
                            width:"100%",
                            textTransform: "uppercase"
                            // backgroundColor: "red",
                        }}
                    >Frequently Asked Questions</Typography>
                    <Typography
                        gutterBottom
                        variant="subtitle2"
                        component="p"
                        fontFamily="Times New Roman"
                        textAlign="center"
                        sx={{
                            fontSize: {xs:"14px",md:"20px"},
                            lineHeight: {xs:"18px",sm:"26px",md:"28px"},
                            pl:{md:"20px"},
                            mb:"20px"
                        }}
                    >
                        Find answers to your queries about our test preparation services, 
                        subscription packages, and more. We are here to help you succeed!
                    </Typography> 
                    {
                        FaqData.map((data,index)=>(
                            
                            <AccordionDesign faqs={data} key={index} />
                            ))
                    }

                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                <Typography variant="h3"
                        textAlign="center"
                        sx={{
                            fontSize: {xs:"18px",sm:"28px",md:"34px",lg:"48px"},
                            fontWeight: "700",
                            textTransform: "uppercase",
                            mt:{xs:"30px",sm:"50px"}
                            // backgroundColor: "yellow"
                        }}
                        >
                        Need More Help?
                    </Typography>
                    <Typography variant="h6"
                        textAlign="center"
                        sx={{
                            fontSize: {xs:"14px",sm:"24px"},
                            fontWeight:{xs:"500",sm:"300"},
                            color:"rgba(0,0,0,0.7)"
                        }}
                        gutterBottom
                        >
                        Contact our support team for further assistance.
                    </Typography>
                    <Button variant="contained"
                        sx={{
                            backgroundColor: "primary.second",
                            color: "white",
                            mt:"20px"
                        }}
                        >
                        Contact Us
                    </Button>
                </Box>
            </Container>
    );
}
export default Faq;